// extracted by mini-css-extract-plugin
export var gif = "_ks-0";